module.exports = __webpack_public_path__ + "static/img/bottom.200399dc.png";